import React from "react";
import { useSelector } from "react-redux";
import { State } from "../../../store";
import EACheckbox from "../../shared/Checkbox/EACheckbox";
import { Controller } from "react-hook-form";

interface IProps {
  errors: any;
  control: any;
  setValue: any;
}

const OtherConsentCheckboxes: React.FC<IProps> = ({ errors, control, setValue }) => {
  const regulaminList = useSelector((state: State) => state.config.configuration.regulaminList);

  const filterRegulaminList = () => {
    const additionalRegulaminList = regulaminList.filter((item) => item.type === "AdditionalTerms");
    return additionalRegulaminList;
  };

  const getNameString = (type: string, index: number): `${string}` => {
    return `${type}${index}` as `${string}`;
  };

  return (
    <div>
      {filterRegulaminList().map((item, index) => (
        <Controller
          name={getNameString(item.type, index)}
          control={control}
          rules={{ required: true }}
          render={({ field }) => (
            <EACheckbox
              name={getNameString(item.type, index)}
              field={field}
              errors={errors}
              label={
                <span>
                  <a target="_blank" href={item.file} rel="noreferrer">
                    *{item.name}
                  </a>
                </span>
              }
            />
          )}
        />
      ))}
    </div>
  );
};

export default OtherConsentCheckboxes;
